import React from "react";
import styled from "@emotion/styled";

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 999999;
  pointer-events: none;
`;

const StyledLoadingStripe = styled.div`
  position: relative;
  width: 100%;
  height: 3px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.04);

  .bar {
    position: absolute;
    top: 0;
    left: -40%;
    width: 40%;
    height: 100%;
    border-radius: 999px;

    background: linear-gradient(
      90deg,
      #ff0000 0%,
      #ff7a00 14%,
      #ffd400 28%,
      #00ff85 42%,
      #00cfff 57%,
      #2f6bff 71%,
      #9b4dff 85%,
      #ff008c 100%
    );

    background-size: 300% 100%;

    box-shadow:
      0 0 8px rgba(255, 0, 140, 0.4),
      0 0 14px rgba(0, 207, 255, 0.3),
      0 0 20px rgba(155, 77, 255, 0.25);

    animation:
      loading 1.2s ease infinite,
      rainbowShift 3s linear infinite;

    will-change: transform, background-position;
  }

  /* soft shimmer effect */
  &::after {
    content: "";
    position: absolute;
    inset: 0;

    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.08),
      transparent
    );

    animation: shimmer 2s linear infinite;
  }

  @keyframes loading {
    0% {
      transform: translateX(0%);
    }

    100% {
      transform: translateX(350%);
    }
  }

  @keyframes rainbowShift {
    0% {
      background-position: 0% 50%;
    }

    100% {
      background-position: 100% 50%;
    }
  }

  @keyframes shimmer {
    0% {
      transform: translateX(-100%);
    }

    100% {
      transform: translateX(100%);
    }
  }
`;

const LoadingStripe = () => {
  return (
    <Wrapper>
      <StyledLoadingStripe>
        <div className="bar" />
      </StyledLoadingStripe>
    </Wrapper>
  );
};

export default LoadingStripe;
